import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Intro, Marquee } from "@/components/site/Intro";
import { Products } from "@/components/site/Products";
import { Vision } from "@/components/site/Vision";
import { HowWeBuild } from "@/components/site/HowWeBuild";
import { Ecosystem } from "@/components/site/Ecosystem";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function MarketingHome() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional mount-only setup/teardown
  }, []);

  return (
    <div className="App grain bg-[#0a0a0f] overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <Intro />
        <Marquee />
        <Products />
        <Vision />
        <HowWeBuild />
        <Ecosystem />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
